<template>
    <div style="background:#F9F9FB">
      <Mainlayout></Mainlayout>
        <br /> <br /> <br /> <br />
      <calendar-component></calendar-component>
    </div>
  </template>
  
  <script>
  import CalendarComponent from '@/components/calendar-component.vue';
  import Mainlayout from "../containers/AllHeader.vue";
  export default {
    components: {
      CalendarComponent,
      Mainlayout,
    }
  };
  </script>
  